/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 15:04:42
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-19 15:31:23
 * @FilePath: /unifyxp-v2-store-portal/src/components/Buttons/AddIconButton/index.tsx
 */
import { Button } from 'src/components/Antd';
import React from 'react';
import styles from './css.module.less';
import { PlusOutlined } from '@ant-design/icons';
const AddIconButton = (props) => {
  const { onClick, text, style } = props;
  return (
    <Button
      style={style}
      type='primary'
      block
      icon={<PlusOutlined className={styles.icon} />}
      className={styles.btnNew}
      onClick={onClick}>
      <span>{text}</span>
    </Button>
  );
};
export default AddIconButton;
